import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=87199476&scoped=true&"
import script from "./finished.vue?vue&type=script&lang=js&"
export * from "./finished.vue?vue&type=script&lang=js&"
import style0 from "./finished.vue?vue&type=style&index=0&id=87199476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87199476",
  null
  
)

export default component.exports